import { apiRequest } from './client';
import type {
  CreateFormTemplateInput,
  FormAnswers,
  FormDraft,
  FormTemplateListItem,
  PreviewResult,
  SaveDraftInput,
} from '../types/forms';

// Fase 23A: cliente HTTP del motor de formularios. El backend valida y es autoritativo; nunca se envia
// businessId (se deriva de la sesion).
const PATH = '/api/forms';

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}
function toQuery(filters: Record<string, string | boolean | undefined>) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== '') query.set(k, String(v)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = query.toString();
  return search ? `?${search}` : '';
}

export const listForms = (filters: { storeId?: string; includeInactive?: boolean } = {}) =>
  apiRequest<{ templates: FormTemplateListItem[] }>(`${PATH}${toQuery(filters)}`);
export const getForm = (id: string) => apiRequest<{ template: FormTemplateListItem }>(`${PATH}/${id}`);
export const createForm = (input: CreateFormTemplateInput) => apiRequest<{ template: FormTemplateListItem }>(PATH, json('POST', input));
export const updateForm = (id: string, input: Partial<CreateFormTemplateInput> & { expectedUpdatedAt?: string }) =>
  apiRequest<{ template: FormTemplateListItem }>(`${PATH}/${id}`, json('PATCH', input));
export const setFormActive = (id: string, isActive: boolean) => apiRequest<{ template: FormTemplateListItem }>(`${PATH}/${id}/activate`, json('POST', { isActive }));
export const deleteForm = (id: string) => apiRequest<{ ok: true }>(`${PATH}/${id}`, { method: 'DELETE' });

export const ensureFormDraft = (id: string) => apiRequest<{ draft: FormDraft }>(`${PATH}/${id}/draft`, json('POST', {}));
export const getFormDraft = (id: string) => apiRequest<{ draft: FormDraft | null }>(`${PATH}/${id}/draft`);
export const saveFormDraft = (id: string, input: SaveDraftInput) => apiRequest<{ draft: FormDraft }>(`${PATH}/${id}/draft`, json('PUT', input));
export const previewForm = (id: string, answers: FormAnswers) => apiRequest<PreviewResult>(`${PATH}/${id}/preview`, json('POST', { answers }));
export const publishForm = (id: string, expectedUpdatedAt?: string) =>
  apiRequest<{ template: FormTemplateListItem; publishedVersionNumber: number }>(`${PATH}/${id}/publish`, json('POST', { expectedUpdatedAt }));
